module.exports = __webpack_public_path__ + "static/032-1bee90fe8dad505266485d958b33fee1.jpg";